"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSearchFilterSearchButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const search_button_1 = require("./search-button");
exports.ManagerSearchFilterSearchButton = (0, styled_components_1.default)(search_button_1.ManagerSearchButton) `
  left: 380px;
`;
//# sourceMappingURL=search-filter-search-button.js.map